import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { GlobalConstants } from './../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-adding-custom-content-to-ipos',
  templateUrl: './ipos-help-adding-custom-content-to-ipos.component.html',
  styleUrls: ['./ipos-help-adding-custom-content-to-ipos.component.scss']
})
export class IposHelpAddingCustomContentToIposComponent implements OnInit, OnChanges {
  @Input() sideNavData;
  @ViewChild('customContent') custom: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('addCustTop') addCustom: ElementRef;
  isContentGrpExpanded = true;
  isCustomContentGrpExpanded = true;
  isCustomContentGrpExpandedIdleExperience  = true;
  formFactorChangeText = GlobalConstants.NOTE_FORM_FACTORS_HELP;
  loginUserRole = sessionStorage.getItem('userRole');
  constructor() { }
  ngOnInit(): void {
    setTimeout(() => {
      this.addCustom.nativeElement.scrollIntoView();
    }, 0);
  }
  ngOnChanges(): void {

  }

  change(data) {
    if (data === 'custom') {
      setTimeout(() => {
        this.custom.nativeElement.scrollIntoView();

      }, 0);
    } else if (data === 'content') {
      setTimeout(() => {
        this.content.nativeElement.scrollIntoView();
      }, 0);
    }
  }
  showDescription(data) {
    if (data === 'customContent') {
      this.isContentGrpExpanded = !this.isContentGrpExpanded;
    } else if (data === 'customContentGroup') {
      this.isCustomContentGrpExpanded = !this.isCustomContentGrpExpanded;
    } else if (data === 'customContentGroupIdleExperience') {
      this.isCustomContentGrpExpandedIdleExperience = !this.isCustomContentGrpExpandedIdleExperience;
    }
  }

}
